<!-- Start Page Title Area -->
<div class="page-title-area page-title-bg1">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>Testimonials</h2>
                    <ul>
                        <li><a routerLink="/" itemprop="url" title="EWNS, Custom Ecommerce Platform to meet all your digital needs">Home</a></li>
                        <li>Testimonials</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/shape2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/shape3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/shape4.png" alt="image"></div>
    <div class="shape-img5"><img src="assets/img/shape/shape5.png" alt="image"></div>
    <div class="shape-img7"><img src="assets/img/shape/shape7.png" alt="image"></div>
    <div class="shape-img8"><img src="assets/img/shape/shape8.png" alt="image"></div>
    <div class="shape-img9"><img src="assets/img/shape/shape9.png" alt="image"></div>
    <div class="shape-img10"><img src="assets/img/shape/shape10.png" alt="image"></div>
</div>
<!-- End Page Title Area -->


<!-- Start Feedback Area -->
<section class="feedback-area ptb-100 bg-color">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Testimonials</span>
            <h2>Some Lovely Feedback From Our Clients</h2>
        </div>
    </div>

    <div class="feedback-slides owl-carousel owl-theme">
        <div class="single-feedback-item">
            <p>“We have seen a huge increase in the number of online contact forms being filled out and returned to us from the time we used EWNS. The end result was a website that is attractive, organized and effective. Thanks to EWNS for all of your hard work and support!”</p>
            <div class="client-info">
                
                <h3> Dr. Ajay</h3>
                <span>Sri Sai Dental Clinic</span>
            </div>
        </div>

        <div class="single-feedback-item">
            <p>“With EWNS's help, we were able to increase the functionality of our website dramatically while cutting our costs. Our website is much more easy to use and is incredibly easy to maintain. We could not be more happy with our new website! Thanks EWNS!”</p>
            <div class="client-info">
                <h3>Sondan Singh</h3>
                <span>Perfect Cabin</span>
            </div>
        </div>

        <div class="single-feedback-item">
            <p>“I would highly recommend EWNS. They are great to work with. I have gone through website redesigns before, and by far, this one was the easiest and least painful and most importantly traffic to our website has increased thanks to their SEO program.”</p>
            <div class="client-info">
                <h3>Dr. Kavitha Reddy</h3>
                <span>Kavitha Reddy Hospital</span>
            </div>
        </div>

        <div class="single-feedback-item">
            <p>“EWNS listened to everything we needed in a new website, then delivered it! Our new website is exciting & easy to use for me & our audiences. I have gone through website redesigns before, and by far, this one was the easiest and least painful.”</p>
            <div class="client-info">
                <h3>Electronic Bazar</h3>
                <span>HP Stores</span>
            </div>
        </div>

        <div class="single-feedback-item">
            <p>“We re-did our website twice in a 12 month period. There was no comparison between the first one and EWNS. Professional, Creative, Attentive to Detail, Excellent Communication. If I had contracted with EWNS the first time I would not have had to do it twice.”</p>
            <div class="client-info">
                <h3>Evoke Dental</h3>
                <span>Evoke Dental Care</span>
            </div>
        </div>
    </div>
</section>
<!-- End Feedback Area -->


<!-- app-banners></app-banners> -->

<!-- Start Subscribe Area -->
<app-subscription></app-subscription>
<!-- End Subscribe Area -->